import React from 'react';
import type { PortfolioItem } from '@/types';
import styles from './PortfolioSection.module.css';

interface PortfolioSectionProps {
  items: PortfolioItem[];
}

export const PortfolioSection: React.FC<PortfolioSectionProps> = ({ items }) => {
  return (
    <section id="portfolio" className={styles.portfolioSpread}>
      <h2 className={styles.title}>Utvalda verk</h2>
      <p className={styles.subtitle}>Från ett urval av uppdragsgivare</p>

      <div className={styles.portfolioGrid}>
        {items.map((item) => (
          <div key={item.id} className={styles.portfolioItem}>
            <img
              src={item.imageSrc}
              alt={`${item.title} - ${item.publication}`}
              className={styles.portfolioImage}
            />
            <div className={styles.portfolioOverlay}>
              <h4>{item.title}</h4>
              <p>{item.publication}, {item.year}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
